const chinaCategories = [
    {
        id: 24, slug: "masiny-i-oborudovanie-promyslennosti",
        names: { cn: "机械及行业设备", kk: "Өнеркәсіп жабдықтары", ru: "Производственное оборудование" },
        products_count: 413041,
        image: "https://b2b-prod.object.pscloud.io/category/152/01K1XR9P7EH9X2KMNXQJ76YPKV.svg",
    },
    {
        id: 20, slug: "stroitelnye-materialy-dlia-obustroistva-doma",
        names: { cn: "家装建材", kk: "Үй құрылыс материалдары", ru: "Стройматериалы для дома" },
        products_count: 296462,
        image: "https://b2b-prod.object.pscloud.io/category/149/01K1XR40SEE9QWHTS610VQ80MX.svg",
    },
    {
        id: 45, slug: "ofis-kultura",
        names: { cn: "办公、文化", kk: "Кеңсе, мәдениет", ru: "Офис и творчество" },
        products_count: 262620,
        image: "https://b2b-prod.object.pscloud.io/category/163/01K1XRV1YABZNMMC1BWDYX60HQ.svg",
    },
    {
        id: 33, slug: "oborudovanie-instrumenty",
        names: { cn: "五金、工具", kk: "Жабдықтар, құралдар", ru: "Оборудование, инструменты" },
        products_count: 243445,
        image: "https://b2b-prod.object.pscloud.io/category/167/01K1XS07X28PB6P9EK72H41TMQ.svg",
    },
    {
        id: 46, slug: "cifrovoi-kompiuter",
        names: { cn: "数码、电脑", kk: "Сандық, компьютер", ru: "Цифровой, компьютер" },
        products_count: 234420,
        image: "https://b2b-prod.object.pscloud.io/category/164/01K1XRW5R99FSC1VA6FDZF20AB.svg",
    },
    {
        id: 42, slug: "sport-na-otkrytom-vozduxe",
        names: { cn: "运动户外", kk: "Ашық спорт", ru: "Спорт на открытом воздухе" },
        products_count: 236285,
        image: "https://b2b-prod.object.pscloud.io/category/161/01K1XRSZ0ZRFXG48MC14YKHYDT.svg",
    },
    {
        id: 43, slug: "elektriceskie-elektriceskie",
        names: { cn: "电工电气", kk: "Электрлік жабдықтар", ru: "Электрика и компоненты" },
        products_count: 223183,
        image: "https://b2b-prod.object.pscloud.io/category/162/01K1XRTH4Z2A4YTY91H20RCKTS.svg",
    },
    {
        id: 47, slug: "upakovka",
        names: { cn: "包装", kk: "Орау", ru: "Упаковка" },
        products_count: 217968,
        image: "https://b2b-prod.object.pscloud.io/category/165/01K1XRWV2F80WFZ9DN9TGZ2VPR.svg",
    },
    {
        id: 12, slug: "ezednevnaia-kuxnia-i-napitki",
        names: { cn: "日用餐厨饮具", kk: "Ас үй жабдықтары", ru: "Всё для кухни" },
        products_count: 214437,
        image: "https://b2b-prod.object.pscloud.io/category/146/01K1XR0C6Z1M01TH7FQ69BNS09.svg",
    },
    {
        id: 22, slug: "igruski",
        names: { cn: "玩具", kk: "Ойыншықтар", ru: "Игрушки" },
        products_count: 206631,
        image: "https://b2b-prod.object.pscloud.io/category/150/01K1XR4TFSS1R90GNKGRHA05AP.svg",
    },
    {
        id: 58, slug: "avtomotor-i-aksessuary",
        names: { cn: "汽摩及配件", kk: "Авто және аксессуарлар", ru: "Транспортные запчасти" },
        products_count: 198603,
        image: "https://b2b-prod.object.pscloud.io/category/171/01K1XS2NB92FTCK1T46ANE534N.svg",
    },
    {
        id: 9, slug: "avtomobilnye-prinadleznosti",
        names: { cn: "汽车用品", kk: "Автокөлік тауарлары", ru: "Автотовары" },
        products_count: 196597,
        image: "https://b2b-prod.object.pscloud.io/category/140/01K1X0PD6K8V886909EJ26XNCK.svg",
    },
    {
        id: 29, slug: "aksessuary-i-aksessuary-dlia-odezdy",
        names: { cn: "服饰配件、饰品", kk: "Киім аксессуарлары", ru: "Бижутерия и аксессуары" },
        products_count: 173931,
        image: "https://b2b-prod.object.pscloud.io/category/153/01K1XRAKJRMFJ48T5DP1J6FJ79.svg",
    },
    {
        id: 40, slug: "bytovaia-texnika",
        names: { cn: "家用电器", kk: "Тұрмыстық техника", ru: "Бытовая техника" },
        products_count: 140096,
        image: "https://b2b-prod.object.pscloud.io/category/160/01K1XRR95WM49W738HEA7NWCSX.svg",
    },
    {
        id: 14, slug: "uborka-dlia-xraneniia",
        names: { cn: "收纳清洁用具", kk: "Тазалық және сақтау", ru: "Уборка и хранение" },
        products_count: 138689,
        image: "https://b2b-prod.object.pscloud.io/category/147/01K1XR26K35P8VBZF2B84BVC8D.svg",
    },
    {
        id: 37, slug: "domasnii-tekstil",
        names: { cn: "家纺家饰", kk: "Үй тоқыма бұйымдары", ru: "Домашний текстиль" },
        products_count: 112177,
        image: "https://b2b-prod.object.pscloud.io/category/157/01K1XRNAB0N9TJSZW9THXKECM1.svg",
    },
    {
        id: 39, slug: "tekstil-koza",
        names: { cn: "纺织、皮革", kk: "Тоқыма, былғары", ru: "Текстиль, кожа" },
        products_count: 118220,
        image: "https://b2b-prod.object.pscloud.io/category/159/01K1XRQC9V512S4ECJNWTH7AYV.svg",
    },
    {
        id: 44, slug: "bezopasnost-zashhita",
        names: { cn: "安全、防护", kk: "Қауіпсіздік, қорғау", ru: "Безопасность, защита" },
        products_count: 98021,
        image: "https://b2b-prod.object.pscloud.io/category/172/01K38QAZ9E6KMPXR9ECX51QADQ.svg",
    },
    {
        id: 4, slug: "obuv",
        names: { cn: "鞋", kk: "Аяқ киім", ru: "Обувь" },
        products_count: 90343,
        image: "https://b2b-prod.object.pscloud.io/category/141/01K1X0T9DFH9K0FTYJ9XZ3NPS7.svg",
    },
    {
        id: 35, slug: "domasnie-predmety-pervoi-neobxodimosti",
        names: { cn: "居家日用品", kk: "Үй заттары", ru: "Мелочи для дома" },
        products_count: 77556,
        image: "https://b2b-prod.object.pscloud.io/category/158/01K1XRNWGG2KYA5VEWQHF1EZZ3.svg",
    },
    {
        id: 31, slug: "elektronnye-komponenty",
        names: { cn: "电子元器件", kk: "Электрондық компоненттер", ru: "Электронные компоненты" },
        products_count: 74769,
        image: "https://b2b-prod.object.pscloud.io/category/155/01K1XRDPTT9SJ6N96Q751GH1XZ.svg",
    },
    {
        id: 15, slug: "kozanye-cemodany",
        names: { cn: "背包和包袋", kk: "Рюкзактар мен сөмкелер", ru: "Сумки и рюкзаки" },
        products_count: 70602,
        image: "https://b2b-prod.object.pscloud.io/category/145/01K1X105CB9Q13DHXF237T8C59.svg",
    },
    {
        id: 10, slug: "domasnie-zivotnye-i-sadovodstvo",
        names: { cn: "宠物及园艺", kk: "Үй жануарлары және бақша", ru: "Домашние животные и садоводство" },
        products_count: 64640,
        image: "https://b2b-prod.object.pscloud.io/category/143/01K1X0WC3TAYZC1XEKQRQ6JY87.svg",
    },
    {
        id: 1, slug: "muzskaia-odezda",
        names: { cn: "男装", kk: "Ерлер киімі", ru: "Мужская одежда" },
        products_count: 58697,
        image: "https://b2b-prod.object.pscloud.io/category/138/01K1X0CEZG53TS8PCTA4CXFVWG.svg",
    },
    {
        id: 53, slug: "niznee-bele",
        names: { cn: "内衣", kk: "Іш киім", ru: "Нижнее бельё" },
        products_count: 38761,
        image: "https://b2b-prod.object.pscloud.io/category/169/01K1XS1HF3Q6MBVJ02SG4ZZS4A.svg",
    },
    {
        id: 30, slug: "rezinovye-plastiki",
        names: { cn: "橡塑", kk: "Резеңке және пластик", ru: "Резина и пластик" },
        products_count: 39671,
        image: "https://b2b-prod.object.pscloud.io/category/154/01K1XRC7CF5GJCKFA733E7HNTS.svg",
    },
    {
        id: 5, slug: "stroitelnye-materialy",
        names: { cn: "建材", kk: "Құрылыс материалдары", ru: "Строительные материалы" },
        products_count: 27139,
        image: "https://b2b-prod.object.pscloud.io/category/142/01K1X0V6ERG7R7FGV9V6EZPCHD.svg",
    },
    {
        id: 55, slug: "pecat",
        names: { cn: "印刷", kk: "Басып шығару", ru: "Печать" },
        products_count: 27888,
        image: "https://b2b-prod.object.pscloud.io/category/170/01K1XS210ZTKMXVBN2RPYPXPYH.svg",
    },
    {
        id: 51, slug: "detskaia-odezda",
        names: { cn: "童装", kk: "Балалар киімі", ru: "Детская одежда" },
        products_count: 31188,
        image: "https://b2b-prod.object.pscloud.io/category/168/01K1XS100QWK6XJYCRD307S9GS.svg",
    },
    {
        id: 2, slug: "zenskaia-odezda",
        names: { cn: "女装", kk: "Әйелдер киімі", ru: "Женская одежда" },
        products_count: 103211,
        image: "https://b2b-prod.object.pscloud.io/category/139/01K1X0MKBSGCQ3AATTMG7Y7GBD.svg",
    },
    {
        id: 23, slug: "kommunikacionnye-produkty",
        names: { cn: "通信产品", kk: "Байланыс өнімдері", ru: "Связь и коммуникации" },
        products_count: 4230,
        image: "https://b2b-prod.object.pscloud.io/category/151/01K1XR7ZCNAY2G5S0S8204N338.svg",
    },
    {
        id: 18, slug: "stanki",
        names: { cn: "机床", kk: "Станоктар", ru: "Станки" },
        products_count: 3667,
        image: "https://b2b-prod.object.pscloud.io/category/148/01K1XR361FM12VZPT04JDT9XTV.svg",
    },
    {
        id: 49, slug: "zashhitasemia-cin",
        names: { cn: "个护/家清", kk: "Жеке гигиена / Тұрмыстық химия", ru: "Личная гигиена / Бытовая химия" },
        products_count: 15630,
        image: "https://b2b-prod.object.pscloud.io/category/166/01K1XRZ819FG4V9VC20Z62EDG8.svg",
    },
    {
        id: 11, slug: "transport",
        names: { cn: "交通运输", kk: "Көлік", ru: "Транспорт" },
        products_count: 7691,
        image: "https://b2b-prod.object.pscloud.io/category/144/01K1X0X7AA9E3Q9HKJ7B9R0ZF9.svg",
    },
    {
        id: 54, slug: "kosmetika-po-uxodu-za-kozeimakiiaz",
        names: { cn: "美容护肤/彩妆", kk: "Тері күтімі косметикасы / макияж", ru: "Косметика и макияж" },
        products_count: 0,
        image: null,
    },
];

export default chinaCategories;
